<template>
  <div class="uk-grid uk-child-width-1-1" data-uk-grid>
    <div>
      <div class="uk-align-right">
        <a @click.prevent="$router.go(-1)" class="uk-button uk-button-small uk-button-secondary">
          <span class="uk-margin-small-right uk-icon" uk-icon="icon: arrow-left"></span>
          Zurück
        </a>
      </div>
    </div>
    <div>
      <ul uk-tab>
        <li><a href="#">Händlerdaten</a></li>
        <li><a href="#">Bestellungen</a></li>
        <li><a href="#">Angebote</a></li>
      </ul>

      <ul class="uk-switcher uk-margin">
        <li>
          <div class="uk-card uk-card-small uk-card-default uk-box-shadow-small uk-margin-bottom">
            <div class="uk-card-body">
              <div class="uk-grid" data-uk-grid>
                <div class="uk-width-1-2@m">
                  <div class="uk-grid" uk-grid>
                    <div class="uk-width-1-1">
                      <div class="uk-margin">
                        <label class="uk-form-label" for="company">Firma</label>
                        <div class="uk-form-controls">
                          <input
                            class="uk-input"
                            id="company"
                            name="company"
                            type="text"
                            v-model="form.company"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="uk-width-1-1 uk-margin-top">
                      <div class="uk-margin">
                        <label class="uk-form-label" for="street">Straße</label>
                        <div class="uk-form-controls">
                          <input
                            class="uk-input"
                            id="street"
                            type="text"
                            name="street"
                            v-model="form.street"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="uk-width-1-2@m uk-margin-top">
                      <div class="uk-margin">
                        <label class="uk-form-label" for="zipcode">PLZ</label>
                        <div class="uk-form-controls">
                          <input
                            class="uk-input"
                            id="zipcode"
                            type="text"
                            name="zipcode"
                            v-model="form.zipcode"
                          />
                        </div>
                      </div>
                      <div class="uk-margin">
                        <label class="uk-form-label" for="country">Land</label>
                        <div class="uk-form-controls">
                           <v-select v-model="form.country" :options="countries" :clearable="false" :searchable="false"></v-select>
                        </div>
                      </div>
                      <div class="uk-margin">
                        <label class="uk-form-label" for="phone">Telefon</label>
                        <div class="uk-form-controls">
                          <input
                            class="uk-input"
                            id="phone"
                            type="text"
                            name="phone"
                            v-model="form.phone"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="uk-width-1-2@m uk-margin-top">
                      <div class="uk-margin">
                        <label class="uk-form-label" for="city">Ort</label>
                        <div class="uk-form-controls">
                          <input
                            class="uk-input"
                            id="city"
                            type="text"
                            name="city"
                            v-model="form.city"
                          />
                        </div>
                      </div>
                      <div class="uk-margin">
                        <label class="uk-form-label" for="ustid">USt.-Id.-Nr./VAT</label>
                        <div class="uk-form-controls">
                          <input
                            class="uk-input"
                            id="ustid"
                            type="text"
                            name="ustid"
                            v-model="form.ustid"
                          />
                        </div>
                      </div>
                      <div class="uk-margin">
                        <label class="uk-form-label" for="fax">Fax</label>
                        <div class="uk-form-controls">
                          <input
                            class="uk-input"
                            id="fax"
                            type="text"
                            name="fax"
                            v-model="form.fax"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="uk-width-1-2@m">
                  <h5 class="uk-text-bold">Ansprechpartner</h5>
                  <div class="uk-grid uk-grid-small" data-uk-grid>
                    <div class="uk-width-1-2@m">
                      <div class="uk-margin">
                        <label class="uk-form-label" for="firstname">Anrede</label>
                        <div class="uk-form-controls">
                          <select class="uk-select" v-model="form.salutation">
                            <option value="Herr">Herr</option>
                            <option value="Frau">Frau</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="uk-grid uk-grid-small" data-uk-grid>
                    <div class="uk-width-1-2@m">
                      <div class="uk-margin">
                        <label class="uk-form-label" for="firstname">Vorname</label>
                        <div class="uk-form-controls">
                          <input
                            class="uk-input"
                            id="firstname"
                            name="firstname"
                            type="text"
                            v-model="form.firstname"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="uk-width-1-2@m">
                      <div class="uk-margin">
                        <label class="uk-form-label" for="lastname">Nachname</label>
                        <div class="uk-form-controls">
                          <input
                            class="uk-input"
                            id="lastname"
                            type="text"
                            name="lastname"
                            v-model="form.lastname"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="uk-width-1-2@m">
                      <div class="uk-margin">
                        <label class="uk-form-label" for="email">E-Mail Adresse</label>
                        <div class="uk-form-controls">
                          <input
                            class="uk-input"
                            id="email"
                            type="text"
                            name="email"
                            v-model="form.email"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="uk-width-1-2@m">
                      <div class="uk-margin">
                        <label class="uk-form-label" for="mobile">Mobil</label>
                        <div class="uk-form-controls">
                          <input
                            class="uk-input"
                            id="mobile"
                            type="text"
                            name="mobile"
                            v-model="form.mobile"
                          />
                        </div>
                      </div>
                    </div>
                    <template v-if="form.files && form.files.length">
                      <h5 class="uk-text-bold">Dateien</h5>
                      <div class="uk-width-1-1">
                        <ul class="uk-list">
                          <li class="uk-margin-remove" v-for="file in form.files" :key="file.id">
                            <a
                              href="#"
                              @click.prevent="
                                downloadFile(
                                  file.id,
                                  `${file.typeLabel}-${form.company}.${file.extension}`
                                )
                              "
                              >{{ file.typeLabel }}</a
                            >
                          </li>
                        </ul>
                      </div>
                    </template>
                  </div>
                  <template v-if="form.data">
                    <template v-if="form.data.condition && form.data.condition.length">
                      <h5 class="uk-text-bold uk-margin-small">Ausgewählte Zustände</h5>
                      <div class="uk-grid uk-grid-small" data-uk-grid>
                        <div class="uk-width-1-1">
                          <p>{{ form.data.condition.join(', ') }}</p>
                        </div>
                      </div>
                    </template>
                     <template v-if="form.data.type && form.data.type.length">
                      <h5 class="uk-text-bold uk-margin-small">Ausgewählte Arten</h5>
                      <div class="uk-grid uk-grid-small" data-uk-grid>
                        <div class="uk-width-1-1">
                          <p>{{ form.data.type.join(', ') }}</p>
                        </div>
                      </div>
                    </template>
                    <template v-if="form.data.delivery && form.data.delivery.length">
                      <h5 class="uk-text-bold uk-margin-small">Ausgewählte Lieferzeiten</h5>
                      <div class="uk-grid uk-grid-small" data-uk-grid>
                        <div class="uk-width-1-1">
                          <p>{{ form.data.delivery.join(', ') }}</p>
                        </div>
                      </div>
                    </template>
                    <template v-if="form.data && form.data.makes.length">
                      <h5 class="uk-text-bold uk-margin-small">Ausgewählte Marken</h5>
                      <div class="uk-grid uk-grid-small" data-uk-grid>
                        <div class="uk-width-1-1">
                          <p>{{ form.data.makes.join(', ') }}</p>
                        </div>
                      </div>
                    </template>
                  </template>
                </div>
                <div class="uk-width-1-1">
                  <hr>
                  <div class="uk-grid" data-uk-grid>
                    <div class="uk-width-1-4@m">
                       <label class="uk-form-label">Bearbeiter / Verkäufer</label>
                      <v-select
                        :options="users"
                        v-model="form.editor"
                        label="name"
                        :reduce="user => user.id"
                        :searchable="false"
                        placeholder="Bitte wählen"
                        appendToBody
                      >
                      </v-select>
                    </div>
                    <div class="uk-width-1-4@m" v-if="tenant.knumber === 'K10149'">
                      <div class="uk-position-relative">
                        <div class="uk-position-absolute">
                          <label class="uk-form-label uk-flex uk-flex-top">DMS Geschäftspartner ID
                            <span data-uk-icon="icon:question; ratio: 0.7" class="uk-margin-small-left"></span>
                          </label>
                          <div uk-drop="pos: right;delay-hide:0">
                            <div class="uk-card uk-card-body uk-card-default uk-padding-small uk-text-small">
                              <p>Kunden ID des DMS Geschäftspartners zum erstellen des Kaufvertrages nach der Bestellung eingeben.</p>
                              <strong>Eine Änderung wird nur benötigt wenn keine automatische Zuordnung erfolgt ist (INT-Nummer).</strong>
                            </div>
                          </div>
                        </div>
                        <input type="text" class="uk-input uk-margin-top" v-model="form.dms_customer_id">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="uk-width-1-1">
                  <div class="uk-align-right">
                    <button
                      type="submit"
                      class="uk-button uk-button-primary"
                      @click.prevent="store"
                    >
                      Daten speichern
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div>
            <sale-list :sales="sales"></sale-list>
          </div>
        </li>
        <li>
          <div>
            <offer-list :offers="offers"></offer-list>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import MerchantService from '@/services/merchant.service'
import SaleList from '@/components/SaleList'
import OfferList from '@/components/offer/OfferList'
import 'izitoast/dist/css/iziToast.min.css'
import iziToast from 'izitoast/dist/js/iziToast.min.js'
import axios from 'axios'
import Configuration from '@/configuration';
import userService from '../../services/user.service'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      form: {
        company: '',
        firstname: '',
        lastname: '',
        ustid: '',
        street: '',
        zipcode: '',
        country: '',
        phone: '',
        fax: '',
        city: '',
        mobile: '',
        email: '',
        salutation: '',
        editor: null,
        dms_customer_id: ''
      },
      countries: [
        'Deutschland',
        'Österreich',
        'Belgien',
        'Polen',
        'Dänemark',
        'Bulgarien',
        'Estland',
        'Finnland',
        'Frankreich',
        'Griechenland',
        'Grossbritannien',
        'Holland',
        'Italien',
        'Irland',
        'Kroatien',
        'Lettland',
        'Litauen',
        'Luxemburg',
        'Malta',
        'Norwegen',
        'Portugal',
        'Rumänien',
        'Schweden',
        'Slowakei',
        'Slowenien',
        'Spanien',
        'Tschechien',
        'Ungarn',
        'Zypern'
      ],
      sales: [],
      offers: [],
      users: []
    }
  },
  components: {
    SaleList,
    OfferList
  },
  mounted() {
    this.getMerchant()
    this.getUsers()
  },
  computed: {
    ...mapGetters(['tenant'])
  },
  methods: {
    getMerchant() {
      MerchantService.get(this.$route.params.id).then(response => {
        this.form = response.data
        this.sales = response.data.sales
        this.offers = response.data.offers
      })
    },
    async getUsers() {
      const users = await userService.getList()
      this.users = users.data
    },
    async store() {
      await MerchantService.store(this.$route.params.id, this.form)
      iziToast.success({
        title: 'OK',
        message: 'Daten gespeichert!',
        timeout: 3000,
        position: 'topCenter'
      })
    },
    downloadFile(id, name) {
      axios({
        url: `${Configuration.value('apiBackend')}/merchant/download-file/${id}`,
        method: 'GET',
        responseType: 'blob' // important
      }).then(response => {
        console.log(response)
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()
      })
    }
  }
}
</script>
